import { useNavigate } from 'react-router';
import {
  Icon,
  IconType,
  Loader,
  QueryBoundary,
  Size,
  modifiers,
} from '@outdoria/ui';
import { useCurrentRoute, useMe } from '../../../hooks';
import { sidebar } from '../../../router/routesMain';

import s from './Sidebar.module.scss';

export const Sidebar = () => (
  <QueryBoundary fallback={<Sidebar.Skeleton />}>
    <Load />
  </QueryBoundary>
);

const Load = () => {
  const navigate = useNavigate();
  const { isLoggedIn, isAdmin, logoutUser } = useMe();

  const { pathname } = useCurrentRoute();

  const mainRoutes = sidebar.map(route => {
    if (!route.handle) return null;

    const {
      path,
      handle: { title, icon },
    } = route;
    const isActive = path === pathname;

    const onClick = () => {
      if (path) navigate(path);
    };
    return (
      <SidebarButton
        key={title}
        label={title}
        icon={icon}
        isActive={isActive}
        onClick={onClick}
      />
    );
  });

  if (!isLoggedIn || !isAdmin) return <Sidebar.Skeleton />;

  return (
    <div className={s.sidebar}>
      <div className={s.sidebar__navigation}>{mainRoutes}</div>

      <SidebarButton icon="Logout" label="Logout" onClick={logoutUser} />
    </div>
  );
};

type SidebarButtonProps = {
  icon: IconType;
  label: string;
  isActive?: boolean;
  onClick: () => void;
};
const SidebarButton = ({
  icon,
  label,
  isActive,
  onClick,
}: SidebarButtonProps) => {
  return (
    <button className={modifiers(s, 'button', { isActive })} onClick={onClick}>
      <Icon icon={icon} size={Size.MICRO} />
      {label}
    </button>
  );
};

Sidebar.Skeleton = () => (
  <div className={s.sidebar}>
    <Loader />
  </div>
);
